import useAssistantPanelAnalytics from "components/AssistantPanel/analytics/useAnalytics";
import { ChatMode } from "components/AssistantPanel/Chat/types";
import useAssistantPanelSendPrompt from "components/AssistantPanel/hooks/useSendPrompt";
import { STACK_CREATION_PROMPT } from "components/AssistantPanel/prompts";
import { ChevronDown, Edit, LogoInfraAssistantColored } from "components/icons/generated";
import Box from "ds/components/Box";
import Button from "ds/components/Button";
import LinkButton from "ds/components/Button/LinkButton";
import DropdownMenu from "ds/components/DropdownMenu";
import DropdownMenuItem from "ds/components/DropdownMenu/Item";
import Icon from "ds/components/Icon";
import Tooltip from "ds/components/Tooltip";
import { AnalyticsPageStack } from "hooks/useAnalytics/pages/stack";
import useIntelligenceSettings from "shared/Intelligence/useIntelligenceSettings";
import useCanCreateStack from "shared/Stack/access/useCanCreateStack";

const NEW_STACK_PATH = "/new/stack";

const StacksCreateStackButton = () => {
  const canCreateStack = useCanCreateStack();
  const { canUseInfraAssistant } = useIntelligenceSettings();
  const { openPrompt, isChatOpen } = useAssistantPanelSendPrompt();
  const { trackConversationOpened } = useAssistantPanelAnalytics();

  const handleCreateWithAssistant = () => {
    trackConversationOpened("stack_creation");

    openPrompt(STACK_CREATION_PROMPT, { newChat: !isChatOpen, mode: ChatMode.BUILD });
  };

  if (!canCreateStack.result || !canUseInfraAssistant) {
    return (
      <Tooltip
        active={!!canCreateStack.message}
        on={(props) => (
          <LinkButton
            {...props}
            to={NEW_STACK_PATH}
            variant="primary"
            disabled={!canCreateStack.result}
            analyticsPage={AnalyticsPageStack.StacksList}
            analyticsTitle="Create Stack"
          >
            Create stack
          </LinkButton>
        )}
      >
        {canCreateStack.message}
      </Tooltip>
    );
  }

  return (
    <DropdownMenu
      placement="bottom right"
      triggerComponent={
        <Button variant="primary" endIcon={ChevronDown}>
          Create stack
        </Button>
      }
    >
      <DropdownMenuItem
        href={NEW_STACK_PATH}
        analyticsPage={AnalyticsPageStack.StacksList}
        analyticsTitle="Create Stack"
      >
        <Box gap="medium" align="center">
          <Icon src={Edit} />
          Create manually
        </Box>
      </DropdownMenuItem>

      <DropdownMenuItem
        onAction={handleCreateWithAssistant}
        analyticsPage={AnalyticsPageStack.StacksList}
        analyticsTitle="Create Stack With Infra Assistant"
      >
        <Box gap="medium" align="center">
          <Icon src={LogoInfraAssistantColored} />
          Create with Infra Assistant
        </Box>
      </DropdownMenuItem>
    </DropdownMenu>
  );
};

export default StacksCreateStackButton;
